import { AddressesApiRemoteService } from '../../Services/api/addresses/addresses-service'
import { IAddressSearchResponse, ICreateAddressPayload } from '../../Services/api/addresses/addresses.interface'
import { IFormUsecase } from '../../Shared/Protocol/protocol-form-usecase'
import { Result } from '../../Shared/Protocol/protocol-result'


export class CreateAddressesUseCase
implements IFormUsecase<ICreateAddressPayload, void> {
  constructor (private readonly AddressesApi: AddressesApiRemoteService) {}
    

  public async handle (
    data: ICreateAddressPayload
  ): Promise<Result<void>> {
    // eslint-disable-next-line no-useless-catch
    try {

      const response = await this.AddressesApi.create(data)

      if (response.isFailure) {
        return response
      }
    
   
      return Result.ok()
    } catch (error: any) {
      return Result.fail(error)
    }
  }

 
}
